<app-nav [ngClass]="isCorporate() ? 'hidden':'block'"></app-nav>
@if (isTopSectionReady() && shouldShowTopSection()) {
  @defer {
    <app-invitation-banner></app-invitation-banner>
  }
  @defer {
    <app-profile-completion></app-profile-completion>
  }
  
}
<router-outlet />
  <div class="">
    <app-footer [ngClass]="isCorporate() ? 'hidden':'block'" />
  </div>


@defer (on timer(1s)) {
  <app-confirmation-modal [class.hidden]="!isEnableConfirmation()" [isOpen]="isOpen()" (closeModal)="toggleModal($event)"
    (saveAction)="saveChanges($event)">
  </app-confirmation-modal>

  <div class="fixed inset-0 flex items-center justify-center z-[99999] bg-opacity-5 backdrop-blur-[2px]"
    [class.hidden]="!isLoading()">
    <div class="loader"></div>
  </div>

  <app-modal-container [componentRef]="selectedComponent()" [attributes]="modalAttributes()" [inputs]="inputs()"
    [isClose]="isClose()" (onClose)="onCloseEvent($event)"></app-modal-container>
  <div class="relative z-[9999]">
    @if(toaster.show()) {
    <app-toaster [msg]="toaster.message()" [type]="toaster.type()" (closed)="toaster.close()" />
    }
  </div>
  
} @placeholder {
  <div></div>
}
